import React from "react";
import ReactDOM from "react-dom/client";
//import "./index.css";
import { Provider } from "react-redux";
import store from "./app/redux/store";
import reportWebVitals from "./reportWebVitals";
import App from "./app/App";
import * as serviceWorker from './serviceWorker';
import AosAnimation from "./app/components/layout/AosAnimation";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <App />
    </Provider>
    <AosAnimation />
  </>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.register();
//serviceWorker.installButton();
